import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { TitleChange } from '../services/title-change';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-justin-martyr',
  imports: [Link, RouterLink],
  templateUrl: './justin-martyr.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './justin-martyr.scss',
})
export class JustinMartyr {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Justin Martyr`);
    this.dynamicTitle.description(`Justin Martyr's writings do not provide any historical evidence for the existence of Jesus as a historical figure.`);
  }
}
